import { collection, get, all, update } from "typesaurus"
import { GroupType, AccountType, GeoState } from "../types"

export interface School {
  id: string
  created: number
  createdBy: string
  lastModified: number
  name: string
  groupType: GroupType
  accountType: AccountType
  state: GeoState
  district: string
  teachers: { [key: string]: boolean }
  students: { [key: string]: boolean }
  admins: { [key: string]: boolean }
  sfid?: string
  deleted?: boolean
  acrobatiq?: boolean
  acrobatiqKey?: string
}

export const collection_ref = collection<School>("schools")

export const getSchoolById = (id: string) => {
  return get(collection_ref, id)
}

export const getAllSchools = () => {
  return all(collection_ref)
}

export const updateSchoolById = (id: string, newVals: Partial<School>) => {
  return update(collection_ref, id, newVals)
}
